import { Navigate, useLocation } from "../hooks/useRouter";
import { REQUIRE_AUTH } from "../constant/globalConstants";
import { ROUTES } from "../constant/keyConstants";
import sidebarConfig from "../config/sidebar.json";

export const isAuthenticated = () => {
  if (!REQUIRE_AUTH) return true;
  return !!localStorage.getItem("token");
};

/**
 * Checks if a requested path is marked as hidden or disabled
 * @param {string} pathname
 * @returns {boolean}
 */
export const isRouteDisabled = (pathname) => {
  const matchingTab = sidebarConfig?.sidebarTabs?.find(
    (tab) => tab.path === pathname || (tab.path && pathname.startsWith(tab.path))
  );
  return matchingTab?.isHidden || matchingTab?.isDisabled;
};

const ProtectedRoute = ({ element: Component, ...rest }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    // Store intended route before redirecting to sign-in
    if (location.pathname !== "/sign-in") {
      sessionStorage.setItem("intendedRoute", location.pathname);
    }
    return <Navigate to="/sign-in" replace />;
  }

  // If accessing a hidden or disabled route, redirect directly to dashboard
  if (isRouteDisabled(location.pathname)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;

